import { render } from "./SigSection.vue?vue&type=template&id=1bcd3363&scoped=true"
import script from "./SigSection.vue?vue&type=script&lang=js"
export * from "./SigSection.vue?vue&type=script&lang=js"

import "./SigSection.vue?vue&type=style&index=0&id=1bcd3363&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcd3363"]])

export default __exports__